export default function(s) {
    var i = Beef.EditBrand.CATEGORY_ITEMS[s];
    s = i ? i.name : s;
    return new Handlebars.SafeString(s || '');
}
